import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Button } from './ui/button';
import { AlertTriangle, Mail } from 'lucide-react';
import { useLanguage } from '../hooks/useLanguage';

const ExportWarningDialog = ({ open, onOpenChange, onConfirm, exportType }) => {
  const { t } = useLanguage();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <div className="p-3 rounded-full bg-yellow-500/10 border border-yellow-500/30">
              <AlertTriangle className="w-6 h-6 text-yellow-500" />
            </div>
            <DialogTitle className="text-left">{t('exportWarningTitle')}</DialogTitle>
          </div>
          <DialogDescription className="text-left pt-4">
            {t('exportWarningMessage')}
          </DialogDescription>
          
          <div className="mt-4 p-4 bg-[#040816]/50 rounded-lg border border-[#00f4ff]/20 flex items-start gap-3">
            <Mail className="w-5 h-5 text-[#00f4ff] mt-0.5 flex-shrink-0" />
            <p className="text-sm text-[#9EB4C0]">
              {t('exportContact')}
            </p>
          </div>
        </DialogHeader>
        
        <DialogFooter className="gap-2 sm:gap-2 mt-4">
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            className="w-full sm:w-auto"
          >
            {t('exportWarningCancel')}
          </Button>
          <Button
            onClick={() => {
              console.log('🔔 Confirm button clicked in modal');
              onConfirm();
              console.log('✅ onConfirm called');
              onOpenChange(false);
            }}
            className="w-full sm:w-auto"
          >
            {t('exportWarningConfirm')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ExportWarningDialog;
